/**
 * Eksport tabeli do CSV dla Excela (średnik, kwoty z przecinkiem, BOM — polskie znaki).
 * Liczby przekazujemy w groszach (number) — zamieniane na „1234,56”; null — puste pole.
 */
export function downloadCsv(fileName: string, header: string[], rows: (string | number | null)[][]) {
  const cell = (v: string | number | null) => {
    if (v === null || v === undefined) return '';
    const s = typeof v === 'number' ? (v / 100).toFixed(2).replace('.', ',') : v;
    return /[;"\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const text = [header, ...rows].map((r) => r.map(cell).join(';')).join('\r\n');
  const blob = new Blob(['﻿', text], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
